import { render, staticRenderFns } from "./Dam.vue?vue&type=template&id=4152c286&"
import script from "./Dam.vue?vue&type=script&lang=ts&"
export * from "./Dam.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports